/* import __COLOCATED_TEMPLATE__ from './posting-create-freelancer-info.hbs'; */
import Component from '@glimmer/component';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-posting-create-freelancer-info';

class PostingCreateFreelancerInfo extends Component {
  @service('states/routes/posting-create') state;

  @readOnly('state.updatedDirectFreelancerUser') freelancerUser;

  get className() {
    return CLASS_NAME;
  }

  get locationClassName() {
    return clsx(
      `${CLASS_NAME}__detail-line`,
      `${CLASS_NAME}__detail-line--location`,
    );
  }
}

export default PostingCreateFreelancerInfo;
